import React, { useState, useEffect } from 'react';
import { fetchCalendarEvents } from '../utils/storage';

export default function CalendarPage() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCalendarEvents()
      .then(events => {
        setEvents(events);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    if (dateStr.length === 10) {
      return { date: date.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' }), time: 'All day' };
    }
    return {
      date: date.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' }),
      time: date.toLocaleTimeString('en-GB', { hour: 'numeric', minute: '2-digit' }),
    };
  };

  if (loading) {
    return (
      <div className="animate-fade-in-up flex justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-500" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="animate-fade-in-up">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Family Calendar</h2>
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-red-100 text-center">
          <p className="text-gray-500">{error}</p>
          <p className="text-sm text-gray-400 mt-2">Try signing out and back in to grant calendar access.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="animate-fade-in-up">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Family Calendar</h2>

      {events.length === 0 ? (
        <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 text-center">
          <div className="text-4xl mb-3">📅</div>
          <p className="text-gray-500">No family events coming up</p>
        </div>
      ) : (
        <div className="space-y-3">
          {events.map(event => {
            const { date, time } = formatDate(event.start);
            return (
              <div
                key={event.id}
                className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100"
              >
                <h3 className="font-semibold text-gray-800">{event.title}</h3>
                <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1 text-sm text-gray-500">
                  <span>{date}</span>
                  <span>{time}</span>
                </div>
                {event.location && (
                  <p className="mt-1 text-sm text-gray-400">{event.location}</p>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
